import React from 'react';

import PlanFilterContainer from '../components/PlanFilterContainer';

const PriorAuth = () => (
  <PlanFilterContainer pageLabel="Prior Authorization Form" />
);

export default PriorAuth;
